
import BANK_LOGO from "client/assets/LOGO/BANK_LOGO.png";

import { useTranslation } from "react-i18next";
import { useCallback, useEffect, useState } from "react";
import { CONFIG } from "../../environment";
import { useLocation, useNavigate } from "react-router";
import AuthService from "../../services/auth.service";
import { useSelector } from "react-redux";
import { modeSelector } from "../../store/selectors/app.selector";
import CommonOtp from "../../components/otp-pre-login";

export default function SelfUnlockOTP(data = {}, setData, setCurrentStep) {
    const { t } = useTranslation();
    const [otp, setOtp] = useState("");
    const location = useLocation();
    const [formValues, setFormValues] = useState(data);
    const mode = useSelector(modeSelector);
    const navigate = useNavigate();
    const [message, setMessage] = useState("");
    const [successVisible, setSuccessVisible] = useState(false);

    useEffect(() => {
    }, []);


    const onConfirm = useCallback(async (values) => {
        try {
            const reqParams = {
                ...values,
            };
            const response = await AuthService.selfUnLockConfirm(reqParams);
            if (response.status === 200) {
                setMessage(response.data["message"]);
                setSuccessVisible(true);
            }
        } catch (error) {
            setOtp("");
        }
    }, []);

    const resendOtp = useCallback(
        async () => {
            try {
                setOtp("");
                const response = await AuthService.selfUnLockVerify(data.data);
                if (response.status === 200) {
                }
            } catch (error) {
                setOtp("");
            }
        },
        []
    );

    return (
        <>
            <CommonOtp
                otp={otp}
                setOtp={setOtp}
                type="TRANSACTION"
                onConfirm={(values) =>
                    onConfirm({ ...data.data, otp: otp })
                }
                handleResendOtp={() => resendOtp()}
                cancelTransaction={() => {
                    navigate("/login");
                }}
                verifyDetails={data.data}
                successVisible={successVisible}
                message={message}
                routingURL={"/login"}
            />
        </>
    );
}